module.exports = __webpack_public_path__ + "img/active-layer4.6c3bc269.png";